import { makeEvaluator } from "../evaluator";
import { Message } from "../message";

type ThreeKeyedLockEvaluatorProps = {
  evalPrompt?: string;
  exitPrompt?: string;
};

export const threeKeyedLockEvaluator = ({
  evalPrompt = "Are there other items to process? If not, say 'done'",
  exitPrompt = "Please provide a final summary of all actions taken.",
}: ThreeKeyedLockEvaluatorProps) =>
  makeEvaluator(({ thread, complete }) => {
    let isEvaluatingTools = true;
    let nextMessageIsSummary = false;

    const onTool = () => {
      nextMessageIsSummary = false;
      isEvaluatingTools = true;
    };

    const onResponse = () => {
      // handle the first non-tool response
      if (isEvaluatingTools) {
        isEvaluatingTools = false;
        nextMessageIsSummary = false;
        thread.send(
          new Message({
            content: evalPrompt,
          })
        );
        return false;
      }
      if (!nextMessageIsSummary) {
        nextMessageIsSummary = true;
        thread.send(
          new Message({
            content: exitPrompt,
          })
        );
        return false;
      }
      cleanup();
      complete(true);
      return true;
    };

    // handle subsequent responses
    thread.on("thread.response", onResponse);

    // re-enter tool running mode, event subscribers will be destroyed when evaluator is done
    thread.on("tool.execution.started", onTool);

    // Cleanup function that will be called when the evaluator is done
    const cleanup = () => {
      thread.off("tool.execution.started", onTool);
      thread.off("thread.response", onResponse);
    };

    // the first time this is called, it will be with the first response, so let's trigger it
    onResponse();

    // Return cleanup function
    return cleanup;
  });
